export default "__VITE_ASSET__h736zk$T__"